// RadioButtonの定数

// 幅広のラベルを使う文字数を指定する(n文字以上)
export const use_large_label = 7;

// key:「電子契約の希望」のmaintenance_id(fm_id)、value:「PINコード送付方法」のfield_column_name
export const pin_method_field_name = {
  2390: 'receptions.desired_pin_code_send_method',
  3160: 'reception_guarantors.1.guarantor_desired_pin_code_send_method',
  3420: 'reception_guarantors.2.guarantor_desired_pin_code_send_method',
  3680: 'reception_guarantors.3.guarantor_desired_pin_code_send_method',
  12370: 'receptions.ma_ad_send_pin',
  18140: 'receptions.desired_pin_code_send_method',
  16700: 'reception_guarantors.4.guarantor_desired_pin_code_send_method',
  16730: 'reception_guarantors.5.guarantor_desired_pin_code_send_method',
  16760: 'reception_guarantors.6.guarantor_desired_pin_code_send_method',
  16790: 'reception_guarantors.7.guarantor_desired_pin_code_send_method',
  16820: 'reception_guarantors.8.guarantor_desired_pin_code_send_method',
  16850: 'reception_guarantors.9.guarantor_desired_pin_code_send_method',
  16880: 'reception_guarantors.10.guarantor_desired_pin_code_send_method',
  16910: 'reception_guarantors.11.guarantor_desired_pin_code_send_method',
  16940: 'reception_guarantors.12.guarantor_desired_pin_code_send_method',
  16970: 'reception_guarantors.13.guarantor_desired_pin_code_send_method',
  17000: 'reception_guarantors.14.guarantor_desired_pin_code_send_method',
  17030: 'reception_guarantors.15.guarantor_desired_pin_code_send_method',
  17060: 'reception_guarantors.16.guarantor_desired_pin_code_send_method',
  17090: 'reception_guarantors.17.guarantor_desired_pin_code_send_method',
  17120: 'reception_guarantors.18.guarantor_desired_pin_code_send_method',
  17150: 'reception_guarantors.19.guarantor_desired_pin_code_send_method',
  17180: 'reception_guarantors.20.guarantor_desired_pin_code_send_method',
  18390: 'reception_guarantors.1.guarantor_desired_pin_code_send_method',
  18400: 'reception_guarantors.2.guarantor_desired_pin_code_send_method',
  18410: 'reception_guarantors.3.guarantor_desired_pin_code_send_method',
}